import React, { useState, useEffect } from "react";
import { AmeaInfrastructureContext } from "./context";

import { getAmeaData } from "../services/services";

import { infrastructuresData } from "../components/Map/utils";
import {
  filterDataSingleValueReturn,
  filterDataWithMultipleDirectives,
} from "../components/Map/helpers";

const AmeaInfrastructureProvider = ({ children }) => {
  const [infrastructureData, setInfrastructureData] = useState(null);
  const [filteredData, setFilteredData] = useState(null);
  const [infrastructureFilters, setInfrastructureFilters] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [refreshFilters, setRefreshFilters] = useState(false);

  const initialInfrastructureFilters = [
    { typeId: "1", type: "category", title: "Ράμπες", isActive: false },
    { typeId: "2", type: "type", title: "Δημόσια", isActive: true },
    {
      typeId: "3",
      type: "category",
      title: "Πεζοδρόμια ΑΜΕΑ",
      isActive: false,
    },
    { typeId: "4", type: "type", title: "Ιδιωτική", isActive: true },
    {
      typeId: "5",
      type: "category",
      title: "Αποδητήρια ΑΜΕΑ",
      isActive: false,
    },
    { typeId: "6", type: "category", title: "Διάβαση τυφλών", isActive: false },
    { typeId: "7", type: "category", title: "Φανάρι με ήχο", isActive: false },
    {
      typeId: "8",
      type: "category",
      title: "Ανελκυστήρες ΑΜΕΑ",
      isActive: false,
    },
    { typeId: "9", type: "category", title: "Άλλο", isActive: false },
  ];

  const handleInfrastructureFilterChange = (filterId, filterValue) => {
    const updatedFilters = infrastructureFilters.map((filter) =>
      filter.typeId === filterId ? { ...filter, isActive: filterValue } : filter
    );
    setInfrastructureFilters(updatedFilters);
    setRefreshFilters(!refreshFilters);
  };

  const handleDataFiltering = (data) => {
    let activeCategories = filterDataSingleValueReturn(
      infrastructureFilters.filter((filter) => filter.type === "category"),
      "isActive",
      "title"
    );
    let activeTypes = filterDataSingleValueReturn(
      infrastructureFilters.filter((filter) => filter.type === "type"),
      "isActive",
      "title"
    );

    if (
      (activeCategories.length === 0 && activeTypes.length === 0) ||
      (activeCategories.length === 0 && activeTypes.length > 1)
    ) {
      setFilteredData(data);
    } else {
      const filteredData = filterDataWithMultipleDirectives(
        data,
        activeCategories,
        activeTypes,
        "category",
        "type"
      );
      setFilteredData(filteredData);
    }
  };

  useEffect(() => {
    const fetchInfrastructures = async () => {
      const infrastructures = await getAmeaData("infra")
        .then((response) => {
          if (response.length > 0) {
            setLoading(false);
            return response;
          } else {
            setLoading(false);
            return infrastructuresData;
          }
        })
        .catch((error) => {
          console.error("Error fetching infrastructures:", error);
          setLoading(false);
          setError(error);
        });

      setInfrastructureData(infrastructures);
      setInfrastructureFilters(initialInfrastructureFilters);
      handleDataFiltering(infrastructures);
    };

    if (!infrastructureData) {
      fetchInfrastructures();
    } else {
      handleDataFiltering(infrastructureData);
    }
  }, [refreshFilters]);

  return (
    <AmeaInfrastructureContext.Provider
      value={{
        infrastructureData: filteredData,
        infrastructureFilters,
        setInfrastructureData,
        handleInfrastructureFilterChange,
        loading,
        error,
      }}
    >
      {children}
    </AmeaInfrastructureContext.Provider>
  );
};

export default AmeaInfrastructureProvider;
